// extracted by mini-css-extract-plugin
export default {"submit-btn":"style_submit-btn__3MwQ2","submitBtn":"style_submit-btn__3MwQ2","error-message":"style_error-message__V2XSJ","errorMessage":"style_error-message__V2XSJ"};